import React, {Component} from 'react';
import {Form, Input,Select, Row, Col, Checkbox,Modal, Button,DatePicker,Cascader,message,Tabs} from 'antd';	
import { connect } from 'react-redux';
import moment from 'moment';

import {getAllAssistListAPI,getTreeListAPI, createCheckBeyondLevelTaskAPI} from '@/API'
import TreeSection from '@/entry_app/common/tree_section'
import { ASSIST,KNOWLEDGEWITHISSUE } from '@/utils/questionManageType';
import {formItemLayout} from '@/constData'
import {questionTypeList} from '../constData'

const FormItem = Form.Item;
const Option = Select.Option;
const TabPane = Tabs.TabPane;



class CreateTaskModal extends Component{
	state={
		postForm:{
			source_type:undefined,
			source_id:[],
			root_id:undefined,
		},
		btnLoading:false,
		sectionList:[],
		assistTreeList:[],
		knowledgeTreeList:[],
		activeTab:'section',
		selectQuestionType:[],
		sectionSelect:[]
	}
	componentDidMount(){
		this.getSectionList()
		this.getKnowLedgeTreeList()
	}
	formatLoop(data){
		return data.map(item=>{
				let option = { value: item.assist_id || item.book_id || item.edition_id, label: item.name }
	            if (item.list) option.children = this.formatLoop(item.list)
	            return option;
			})
	}
	//获取课本教辅
	getSectionList(){
		getAllAssistListAPI().then(res=>{
			let sectionList=this.formatLoop(res.data.list)
			this.setState({sectionList})
		})
	}
	handleSectionChange= (value) => {
        let rootId = value[value.length - 1];
        let params={
        		type: ASSIST, 
        		rootId
        }
        this.setState({sectionSelect:value})
        this.getTreeList(params,'assistTreeList')
    }
	getKnowLedgeTreeList(){
		 let params={
        		type: KNOWLEDGEWITHISSUE, 
        		rootId:0
        }
        this.getTreeList(params,'knowledgeTreeList')
	}
	handleTreeSelect=(selectedKeys)=>{
		let {postForm}=this.state
		postForm.source_id=selectedKeys[0]||undefined
        this.setState({postForm})
    }
	getTreeList(params,treeKey){
		getTreeListAPI(params).then(res=>{
			this.setState({[treeKey]:res.data.list})
		})
	}
	onTabChange = (key) => {
        this.setState({activeTab:key})
    }
	disabledDate=(current)=> {
	  return current && current.valueOf() < Date.now();
	}
	handleSelectQuestionType=(value)=>{
		let allType=questionTypeList.map(v=>{return v.key}),			
			selected=[]
		if(value.includes('all')){
			selected=allType
		}else if(this.state.selectQuestionType.includes('all')){
			selected=[]
		}else{
			selected=value
		}
		this.setState({selectQuestionType:selected})
		
	}
	handleSubmit = (e) => {
	    e.preventDefault();
	    this.props.form.validateFieldsAndScroll((err, values) => {
	      if (!err) {
			 let {postForm}=values
	      	 postForm.dead_time=moment(postForm.dead_time).format('YYYY-MM-DD HH:mm:ss')
	      	 postForm.source_type=this.state.activeTab=='section'?1:26
	      	 postForm.source_id=this.state.postForm.source_id
	      	 postForm.show_type=this.state.selectQuestionType.filter(v=>{return v.key!='all'})
	      	if(!postForm.show_type.length){
	      	 	message.error('请选择题型')
	      	 	return
	      	 }
	      	 if(!postForm.source_id.length){
	      	 	message.error('请选择具体章节或知识点考点')
	      	 	return
	      	 }
	      	 
			this.setState({btnLoading:true});
	      	createCheckBeyondLevelTaskAPI(postForm).then(res=>{
	      	 	message.success('任务创建成功！');
	      	 	this.setState({btnLoading:false})
	      	 	this.props.handleClose('update')
	      	 	this.props.form.resetFields();
	      	 	this.resetPostForm()
	      	 }).catch(e=>{
	      	 	this.setState({btnLoading:false})
	      	 })
	      }
	    });
	 }

	resetPostForm(){
		let initPostForm={
			relate_id:undefined,
			root_id:undefined,
		}
		this.setState({
			postForm:initPostForm,
			selectQuestionType:[],
			sectionSelect:[],
			assistTreeList:[],
			knowledgeTreeList:[],
		})
	}
	renderForm(){
		
		const ruleOption={
			input:{rules: [{ required: true, message: '必填项!', whitespace: true }]},
			date:{rules: [{ type: 'object',required: true, message: '必填项!'}]},
			cascader:{rules: [{ type: 'array',required: true, message: '必填项!'}]},
			mutipleSelect:{rules: [{ type: 'array',required: true, message: '必填项!'}]},
		}
		
		let {sectionList,assistTreeList,knowledgeTreeList,activeTab,selectQuestionType}=this.state
		const { getFieldDecorator } = this.props.form;
	    let { checkUserList}=this.props

		const checkUserOptions = checkUserList.map(v => <Option value={v.id}  key={v.id}>{v.username}</Option>),
			  questionTypeOptions=questionTypeList.map(v => <Option value={v.key}  key={v.key}>{v.name}</Option>)
	   
	   return(
	    		<Form >
				<FormItem {...formItemLayout} label="任务名称" hasFeedback>
		          {getFieldDecorator('postForm.name', ruleOption.input)(<Input /> )}
		        </FormItem>
		        <FormItem {...formItemLayout} label="审查人" hasFeedback>
		          {getFieldDecorator('postForm.check_user', ruleOption.input)(
		          	<Select
		          		showSearch
				        defaultActiveFirstOption={false}
				        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
				      >
	       				{checkUserOptions}
	       			 </Select>
		          )}
		        </FormItem>
		        <FormItem {...formItemLayout} label="审查截止时间" hasFeedback>
		          {getFieldDecorator('postForm.dead_time', ruleOption.date)(<DatePicker style={{width:'286px'}} showTime format="YYYY-MM-DD HH:mm:ss" disabledDate={this.disabledDate} />)}
		        </FormItem>
		        <FormItem {...formItemLayout} label="题型" hasFeedback>
		          	<Select
						mode='multiple'
				        defaultActiveFirstOption={true} 
				        value={selectQuestionType}
				        onChange={this.handleSelectQuestionType}
				      >
	       				{questionTypeOptions}
	       			 </Select>
		        </FormItem>
		        <FormItem {...formItemLayout} label="" >
		          {getFieldDecorator('postForm.skip_checked', { valuePropName: 'checked',initialValue:true })(<Checkbox >跳过已有查超纲任务的题目</Checkbox>)}
		        </FormItem>
				<FormItem {...formItemLayout} label="" >
		          {getFieldDecorator('postForm.skip_start_eight', { valuePropName: 'checked',initialValue:true })(<Checkbox >跳过题目ID开头为8长为六位的题目</Checkbox>)}
		        </FormItem>
		        <Tabs activeKey={activeTab} onChange={ this.onTabChange }>
                    <TabPane tab="章节" key = "section">
                        <Cascader value={this.state.sectionSelect}  popupPlacement="topLeft" allowClear={ false } style={{width:"60%"}} options={sectionList} onChange={ this.handleSectionChange } placeholder="请选择章节" />
                        <TreeSection
                            treeData={assistTreeList }
                            key = { ASSIST }
                            handleTreeSelect= { selectedKeys => this.handleTreeSelect(selectedKeys) }
                            checkable= { false }
                   			checkStrictly = { false }
                        />
                    </TabPane>
                    <TabPane tab="知识点及考点" key="knowledge">
                        <TreeSection
                            treeData={knowledgeTreeList }
                            key = { KNOWLEDGEWITHISSUE }
                            handleTreeSelect = { selectedKeys => this.handleTreeSelect(selectedKeys) }
                            checkable= { false }
                   			checkStrictly = { false }
                        />
                    </TabPane>
                </Tabs>
			</Form>
	    )
		
	}
	
	render(){
		let {btnLoading}=this.state
		let {openCreate,handleClose}=this.props
		return(
			<Modal
	          title="新建任务"
	          visible={openCreate}
	          onCancel={handleClose}
	          footer={[
	            <Button key="cancel"  onClick={handleClose}>取消</Button>,
	            <Button key="save" type="primary"  loading={btnLoading} onClick={this.handleSubmit}>保存</Button>,
	          ]}
	        >
				{this.renderForm()}
			 </Modal>
		)
	}
}


export const WrappedCreateTaskForm = Form.create()(CreateTaskModal)



// WEBPACK FOOTER //
// ./src/entry_app/question_manage/check_beyond_level/modal/create_task.js